"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviousWorkspaceIdWatcher = void 0;
var react_1 = require("react");
exports.PreviousWorkspaceIdWatcher = (0, react_1.memo)(function (_a) {
    var workspaceId = _a.workspaceId, saveWorkspaceId = _a.saveWorkspaceId;
    (0, react_1.useEffect)(function () {
        saveWorkspaceId({ workspaceId: workspaceId });
    }, [workspaceId, saveWorkspaceId]);
    return null;
});
